import React from 'react';
import PropTypes from 'prop-types';

export default class Tab extends React.Component {

	static propTypes = {
		path: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		exact: PropTypes.bool,
	};
	
	static defaultProps = {
		exact: false,
	};
	
}
